import React, { useState, useEffect } from 'react';
import '../../../../Assets/styles/LandingStyles/CookieBanner/CookieBanner.css';

const CookieConsentBanner: React.FC = () => {
    
    return (
        <>
          
        </>
    );
};

export default CookieConsentBanner;